<template>
  <!--1.首先，弹窗页面中要有el-dialog组件即弹窗组件，我们把弹窗中的内容放在el-dialog组件中-->
  <!--2.设置:visible.sync属性，动态绑定一个布尔值，通过这个属性来控制弹窗是否弹出-->
  <el-dialog title="" :visible.sync="detailVisible" :close-on-click-modal="false" :show-close="false" width="60%">
    <div style="margin: 0 30px">
      <div style="border: 6px solid #8e8fe3; border-radius: 30px;display: flex;flex-direction: column;justify-content: center;align-items: center">
        <div style="margin-top: 30px; font-size: 55.33px;color: #508bdd">网站已经更新</div>
        <div style="margin-top: 30px; font-size: 55.33px;color: #508bdd">请点击下面的链接转移到新的网站~</div>
        <div style="margin: 40px 0 80px 0;">
          <a href="https://xiaofaduo.com/plugs" style="color: #fff" target="_blank" >
            <button style="cursor: pointer; border: 7px solid #8e8fe3; border-radius: 45px;background-color: #508bdd;font-size: 74.35px;color: #fff; padding: 0 100px 7px 100px;" >点击跳转</button>
          </a>
        </div>
      </div>
      <div style="margin-top: 30px; font-size: 42.17px;color: #508bdd;display: flex;flex-direction: column;justify-content: center;align-items: center">旧网站已经停止运营,请您跳转新版本！！</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "dialogComponent",
  data(){
    return{
      detailVisible: false
    }
  },
  methods:{
    //3.定义一个init函数，通过设置detailVisible值为true来让弹窗弹出，这个函数会在父组件的方法中被调用
    init(data){
      this.detailVisible = true;
      //data是父组件弹窗传递过来的值，我们可以打印看看
      // console.log(data);
    }
  }
}
</script>
